import type { AxiosResponse } from 'axios';

export const downloadFile = ({ fileName, fileUrl }: { fileName: string; fileUrl: string }) => {
  if (!fileUrl || !fileName) {
    return;
  }

  const aTag = document.createElement('a');
  aTag.href = fileUrl;
  aTag.download = fileName;
  document.body.appendChild(aTag);
  aTag.click();
  document.body.removeChild(aTag);
};

export const downloadFileFromBlob = ({ blob, fileName }: { blob: Blob; fileName: string }) => {
  const url = window.URL.createObjectURL(blob);
  downloadFile({
    fileName: fileName,
    fileUrl: url,
  });
  window.URL.revokeObjectURL(url);
};

export const downloadFileFromBlobRequest = async (options: {
  downloadRequest: Promise<AxiosResponse<Blob>>;
  fileName?: string;
}) => {
  const { downloadRequest, fileName } = options;
  const res = await downloadRequest;

  const disposition = res.headers['content-disposition'] ? res.headers['Content-Disposition'] : '';
  let file_name = fileName;

  if (!fileName) {
    const match = disposition && disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    if (match) {
      file_name = decodeURIComponent(match[1].replace(/['"]/g, ''));
    }
  }

  downloadFileFromBlob({
    blob: new Blob([res.data]),
    fileName: file_name!,
  });
};

export const secondToMinute = (seconds: number) => {
  return Math.ceil(seconds / 60);
};

export const secondToMinuteAndSecond = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return minutes > 0 ? `${minutes}min ${secs}sec` : `${secs}s`;
};
